// Module
var code = "<ng-transclude></ng-transclude> ";
// Exports
module.exports = code;